<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full px">
        <AdminDashboardComponent v-if="isAdmin" />
        <TalentDashboardComponent v-else-if="isTalent" />
        <DashboardComponent v-else />
      </main>
    </div>
  </div>
</template>

<script>
import DashboardComponent from "@/components/DashboardComponent";
// import Navbar from'@/components/NavbarComponent'

import Sidebar from "@/components/SidebarComponent.vue";
import TalentDashboardComponent from "@/components/TalentDashboardComponent.vue";
import AdminDashboardComponent from "@/components/AdminDashboardComponent.vue";

export default {
  name: "DashboardView",
  components: {
    DashboardComponent,
    TalentDashboardComponent,
    AdminDashboardComponent,
    Sidebar,
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.token && this.$store.state.user;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.$router.replace({ name: 'Login' });
        }
      },
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    // Check authentication on mount
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    }
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>
